import { stringIncludes } from '../lib/includes';

/**
 * Adds a symbol to the target URL based on its content.
 * @param {string} target - The target URL to check.
 * @returns -{string} - Returns '&' if the target contains '?', otherwise returns '?'.
 */

const getSymbol = target => (target && stringIncludes(target, '?') ? '&' : '?');

export default getSymbol;
